module.exports = __webpack_public_path__ + "static/media/logo.2959530e.png";